import surveysApi from '@/api/pumba/surveysApi';

export const state = {
    survey: null,
    surveys: [],
};

export const getters = {
    surveys: (state) => state.surveys,
};

export const mutations = {
    SET_SURVEY(state, survey) {
        state.survey = survey;
    },
    SET_SURVEYS(state, surveys) {
        state.surveys = surveys;
    },
    SET_SURVEY_ANSWERED(state, alias) {
        const survey = state.surveys.find((s) => s.alias === alias);
        if (survey) {
            survey.answered = true;
        }
    },
};

export const actions = {
    async fetchSurveys({ commit }) {
        const resp = await surveysApi.fetchSurveys();
        commit('SET_SURVEYS', resp);
        return resp;
    },

    async submitSurvey(_, { alias, payload }) {
        try {
            await surveysApi.submitSurvey(alias, payload);
            _.commit('SET_SURVEY_ANSWERED', alias);
        } catch (e) {
            if (e.response && e.response.status === 400) {
                // Handle specific error if needed
                console.error('Bad Request: ', e.response.data);
            } else {
                throw e;
            }
        }
    },
};

export default {
    state,
    getters,
    mutations,
    actions,
};
